import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LoginButton: React.FC = () => {
  const { loginWithRedirect, logout, isAuthenticated, isLoading } = useAuth0();

  if(isLoading) {
    return (
      <div className="text-center text-gray-500">Chargement...</div>
    );
  }
 
  return (
    <div className="flex justify-center space-x-4">
      {!isAuthenticated ? (
        <button
          className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-hidden focus:ring-2 focus:ring-blue-500/75"
          onClick={() => loginWithRedirect()}
        >
          Connexion
        </button>
      ) : (
        <button
          className="px-6 py-2 bg-red-600 text-white font-semibold rounded-lg shadow-md hover:bg-red-700 focus:outline-hidden focus:ring-2 focus:ring-red-500/75"
          onClick={() => logout({})}
        >
          Déconnexion
        </button>
      )}
    </div>
  );
};

export default LoginButton;
